import { useCallback } from 'react';
import useAuth from '../../authentication/useAuth';
import { useEmailApi } from '../../apis';
import {
	applyEmailRecipientPolicy,
	normalizeEnvironment,
	shouldRedirectEmailRecipients,
} from './policy';

/**
 * Hook adapter for email sending.
 * Keeps transport in services/email while applying environment recipient policy.
 */
export const useEmailService = () => {
	const auth = useAuth();
	const environment = normalizeEnvironment(process.env.REACT_APP_ENV);
	const actualUserEmail = auth?.authenticatedUser?.email || '';
	const { sendEmail: sendEmailEndpoint } = useEmailApi();

	const sendEmail = useCallback(
		async (payload, axiosParams) => {
			const safePayload = payload || {};
			const routedPayload = applyEmailRecipientPolicy(safePayload, {
				environment,
				actualUserEmail,
			});

			const didSubstituteRecipient = routedPayload.to !== safePayload.to;

			if (
				didSubstituteRecipient &&
				shouldRedirectEmailRecipients(environment)
			) {
				/* eslint-disable-next-line no-console */
				console.log('[EmailPolicy] Substituted email recipient for DEV/QA', {
					environment,
					beforeTo: safePayload.to,
					afterTo: routedPayload.to,
				});
			}

			return sendEmailEndpoint(routedPayload, axiosParams);
		},
		[actualUserEmail, environment, sendEmailEndpoint]
	);

	return {
		sendEmail,
		actualUserEmail,
		isEmailRedirectEnabled: shouldRedirectEmailRecipients(environment),
	};
};

export default useEmailService;
